import { RootState } from '@next/core-lib/app';
import { AbstractFormDialogData } from '@next/core-lib/dialog';
import { SessionState } from '@next/core-lib/session';

import { ReportManureSubstancesView, ReportSort } from '../reports/models';
import { SoilType } from '../soil-type/models/soil-type.models';

// add your interfaces for the api responses and state here
// SiteState is the root state of your app module
export interface SiteState extends RootState {
  app: AppState;
}

export interface AppState {
  defaultCropYear?: number;
  defaultSoilType?: number;
  availableCropYears?: number[];
  soilAnalysisByCropFieldId?: SoilAnalysisByCropFieldId[];
  crops?: Crop[];
  cropVarieties?: CropVariety[];
  reportSort?: ReportSort;
  reportManureSubstancesView?: ReportManureSubstancesView;
  customerProgress?: CustomerProgress;
}

export interface ArableSessionState extends SessionState {
  arable?: {
    cropYear?: number;
  };
}

export interface Crop {
  id: number;
  agrifirmCrop: {
    name: string;
  };
}
export interface GetCropsResponse {
  crops: Crop[];
}
export interface CropVariety {
  id: number;
  name: string;
  cropId: number;
}
export interface GetCropVarietiesResponse {
  cropVarieties: CropVariety[];
}
export interface SoilAnalysis {
  id: number;
  customerId: number;
  description: string;
  labId: string;
  receiptDateDateTime: string;
  samplingDateTime: string;
  isManualEntry: boolean;
  borderData: null;
  sampledCharacteristics: SampledCharacteristic[];
}
export interface SampledCharacteristic {
  id: number;
  unitOfMeasurement: string;
  value: number;
  designation: string;
}
export interface SoilAnalysisGroups {
  id: number;
  soilAnalysisIds: number[];
}
export interface GetSoilAnalysesRequestData {
  maxYears: number;
  designationNames: ('P-AL' | 'P-PAE' | 'Pw')[];
  soilAnalysisGroups: SoilAnalysisGroups[];
  oneDesignationSuffices: boolean;
}
export interface SoilAnalysisByCropFieldId {
  id: number;
  soilAnalysis: SoilAnalysis;
}

export interface CropFieldProperties {
  cropId: number;
  cropVarietyId: number;
  soilTypeId: number;
  name: string;
  areaInHectares: number;
}
export interface CropField extends CropFieldProperties {
  id: number;
  soilAnalysisIds: number[];
}
export interface GetCropFieldsResponse {
  cropFields: CropField[];
}

export enum GrasslandUsage {
  Mow = 'Mow',
  Graze = 'Graze',
}

export interface FieldsDialogModel extends AbstractFormDialogData {
  cropFields: CropField[];
  crops: Crop[];
  soilTypes: SoilType[];
  cropYear: number;
}

export interface OptimizedFertilizerRequest {
  cropYear: number;
  nManureBalance: number;
  nTotalBalance: number;
  p2O5Balance: number;
  fertilizer: {
    cropAidId: number;
    periodId: number;
    soilTypeId: number;
  };
}

export interface OptimizedFertilizerResponse {
  allowedDosage: number;
  nManureUsage: number;
  nTotalUsage: number;
  p2O5Usage: number;
}

export interface GetDefaultYearResponse {
  defaultYear: number;
}

export interface CustomerProgress {
  id: number;
  customerId: number;
  year: number;
  processes: CustomerProgressProcesses;
}

export interface CustomerProgressProcesses {
  fieldPlanCropFieldsCompleted: boolean;
  fieldPlanManurespaceCompleted: boolean;
  fieldAdviceFertilizationAdvicesCompleted: boolean;
  fieldAdviceCropProtectionAdvicesCompleted: boolean;
  orderplanningOrderCompleted: boolean;
  manurespaceCalculationsCompleted: boolean;
}
